import styled from '@emotion/styled';
import { commonColors } from 'application/theme';

interface StyledButtonProps {
  styleType: 'default' | 'color' | 'error';
  disabled?: boolean;
}

export const StyledButton = styled.button<StyledButtonProps>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 6px 16px;
  gap: 10px;
  width: 100%;
  height: 48px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.08px;
  color: ${({ styleType }) =>
    styleType === 'color'
      ? commonColors.blue800
      : commonColors[styleType === 'error' ? 'error2' : 'grey700']};
  background-color: ${({ styleType }) =>
    styleType === 'error' ? commonColors.white : 'transparent'};
  border: 1px solid
    ${({ styleType }) =>
      styleType === 'color'
        ? commonColors.blue800
        : commonColors[styleType === 'error' ? 'error2' : 'grey400']};
  box-shadow: 1px 1px 2px rgba(16, 24, 40, 0.12);
  border-radius: 8px;
  cursor: pointer;

  :hover {
    background-color: ${({ styleType }) =>
      styleType === 'color'
        ? commonColors.blue50
        : commonColors[styleType === 'error' ? 'error3' : 'grey100']};
    color: ${({ styleType }) =>
      styleType === 'color'
        ? commonColors.blue800
        : commonColors[styleType === 'error' ? 'error2' : 'grey900']};
  }

  :disabled {
    background-color: ${({ styleType }) =>
      styleType === 'color' ? commonColors.blue50 : commonColors.white};
    border-color: ${({ styleType }) =>
      styleType === 'color' ? commonColors.blue200 : commonColors.grey300};
    color: ${({ styleType }) =>
      styleType === 'color' ? commonColors.blue200 : commonColors.grey300};
    cursor: not-allowed;
  }
`;
